"use client";

import { ServicesPromisesProps } from "./types";
import { memo } from "react";
import { servicesPromisesMap } from "./constants";
import { CertificateSection } from "@/components/screen/global-components/certificate";

const ServicesPromises = ({
  variant = "standard",
  className,
}: ServicesPromisesProps) => {
  return (
    <CertificateSection
      className={className}
      {...servicesPromisesMap[variant]}
      variantSecondary={["quality"].includes(variant)}
    />
  );
};

export default memo(ServicesPromises);
